__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "coremind-foundation-shell";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] = scope[name] || {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@coremind/admin-core", "1.0.1784504899", () => (() => (__webpack_require__(92450))), 1);
			register("@coremind/apps-core", "1.0.1781453190", () => (() => (__webpack_require__(71285))), 1);
			register("@coremind/billing-core", "1.0.1781483760", () => (() => (__webpack_require__(71102))), 1);
			register("@coremind/camera-core", "1.0.1782392208", () => (() => (__webpack_require__(75354))), 1);
			register("@coremind/docs-core", "1.0.1781452723", () => (() => (__webpack_require__(76962))), 1);
			register("@coremind/identity-core", "1.0.1783913444", () => (() => (__webpack_require__(13751))), 1);
			register("@coremind/inventory-core", "1.0.1783903666", () => (() => (__webpack_require__(16993))), 1);
			register("@coremind/marketplace-core", "1.0.1781477614", () => (() => (__webpack_require__(97550))), 1);
			register("@coremind/notifications-core", "1.0.1782392049", () => (() => (__webpack_require__(66281))), 1);
			register("@coremind/storage-core", "1.0.1784504393", () => (() => (__webpack_require__(60753))), 1);
			register("@coremind/ui-platform-core", "1.0.1781452340", () => (() => (__webpack_require__(23263))), 1);
			register("@coremind/users-core", "1.0.1781486578", () => (() => (__webpack_require__(33173))), 1);
			register("@coremind/workspaces-core", "1.0.1784504392", () => (() => (__webpack_require__(41279))), 1);
			register("react-dom", "^19.1.1", () => (() => (__webpack_require__(40961))), 1);
			register("react-router-dom", "^7.9.5", () => (() => (__webpack_require__(66894))), 1);
			register("react", "^19.1.1", () => (() => (__webpack_require__(96540))), 1);
			initExternal(39869);
			initExternal(82727);
			initExternal(84100);
			initExternal(57655);
			initExternal(67872);
			initExternal(55255);
			initExternal(47823);
			initExternal(2603);
			initExternal(59724);
			initExternal(50013);
			initExternal(75706);
			initExternal(47428);
			initExternal(32855);
			initExternal(6664);
			initExternal(43089);
			initExternal(51466);
			initExternal(83803);
			initExternal(10499);
			initExternal(24581);
			initExternal(14913);
			initExternal(37577);
			initExternal(30415);
			initExternal(27349);
			initExternal(62130);
			initExternal(62417);
			initExternal(70394);
			initExternal(62092);
			initExternal(25065);
			initExternal(998);
			initExternal(89650);
			initExternal(92586);
			initExternal(37616);
			initExternal(90217);
			initExternal(93545);
			initExternal(65688);
			initExternal(91935);
			initExternal(34677);
			initExternal(27474);
			initExternal(4392);
			initExternal(56689);
			initExternal(85914);
			initExternal(69660);
			initExternal(29277);
			initExternal(73609);
			initExternal(76308);
			initExternal(40417);
			initExternal(50335);
			initExternal(29931);
			initExternal(54414);
			initExternal(63096);
			initExternal(4539);
			initExternal(75086);
			initExternal(98319);
			initExternal(44961);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};